module.exports = __webpack_public_path__ + "img/home-page.5c3cede0.svg";